import { useAnalytics } from "../lib/analytics";
import { useClientTranslations } from "../lib/i18n/client";
import styles from "./MenuFooter.module.css";
import { Version } from "./Version";

export function MenuFooter() {
	const { t } = useClientTranslations("common");
	const analytics = useAnalytics();

	return (
		<div className={styles.menuFooter}>
			{/* Version */}
			<button
				type="button"
				onClick={() => analytics.logEvent("menu_version_click")}
				className={styles.versionButton}
			>
				<Version />
			</button>

			{/* Legal Links */}
			<div className={styles.legalLinks}>
				<a
					href="https://www.eraborn.co/privacy-policy"
					target="_blank"
					rel="noopener noreferrer"
					className={styles.legalLink}
					onClick={() => analytics.logEvent("menu_privacy_policy_click")}
				>
					{t("navigation.privacyPolicy")}
				</a>
				<span className={styles.separator}>•</span>
				<a
					href="https://www.eraborn.co/terms-of-use"
					target="_blank"
					rel="noopener noreferrer"
					className={styles.legalLink}
					onClick={() => analytics.logEvent("menu_terms_of_service_click")}
				>
					{t("navigation.termsOfService")}
				</a>
			</div>
		</div>
	);
}
